"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
function pageTitle(to, from, next) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        console.group('pageTitle');
        document.title = `${to.meta.name || 'Untitled'} | Timer Agent`;
        console.log(`Page title: "${document.title}"`);
        console.groupEnd();
        return next && next.call ? next() : next;
    });
}
exports.default = pageTitle;
//# sourceMappingURL=pageTitle.js.map